export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-01.428e86f9.svg";